import React from 'react';
import { PRODUCTS } from '../../data/products';
import { Product } from '../../schemas/product';

/**
 * The three forms the one recipe arrives in — the Round, the cubes, the
 * flour. Data lives in products.json; this only decides how a form looks.
 *
 * A form with no `photo` renders a typographic placeholder instead of
 * borrowing a picture of something else. That is deliberate: the flour's
 * package does not exist yet, and the page says so rather than implying a
 * shelf-ready pouch (see marketing/state.md on the render library).
 */
export function ProductsSection() {
  const renderCard = (p: Product) => (
    <article key={p.id} className="product-card">
      <div className="product-card-visual">
        {p.photo ? (
          <img
            src={`${process.env.PUBLIC_URL}${p.photo}`}
            alt={p.alt}
            loading="lazy"
            className="product-card-photo"
          />
        ) : (
          <span className="product-card-placeholder" aria-hidden="true">
            {p.name.replace(/™/g, '')}
          </span>
        )}
        <span className={`product-status product-status-${p.status}`}>{p.statusLabel}</span>
      </div>
      <div className="product-card-body">
        <h3 className="product-card-title">{p.name}</h3>
        <div className="product-card-form">{p.form}</div>
        <p className="product-card-desc">{p.description}</p>
        <ul className="product-notes">
          {p.notes.map((n) => (
            <li key={n}>{n}</li>
          ))}
        </ul>
      </div>
    </article>
  );

  return (
    <section className="section fade-in" style={{ paddingTop: '2rem' }}>
      <div className="section-label">The Line</div>
      <h2>The Round, the cubes, and the flour.</h2>
      <p style={{ maxWidth: '58ch' }}>
        TrueNooch™ is one recipe — eight real ingredients cooked into a single whole food. What
        changes between these is the shape it reaches you in: a log you slice, a cup you carry, or
        a flour you bake with.
      </p>
      <div className="product-grid">{PRODUCTS.map(renderCard)}</div>
    </section>
  );
}
